// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    margin: 10,
    boxShadow: '9px 9px 30px -20px rgba(0,0,0,0.75)',
    [theme.breakpoints.down(450)]: {
      width: '100%',
    },
  },
  processing: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
    '&:hover': {
      backgroundColor: 'rgba(225, 50, 90, 1)',
    }
  },
  paid: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
    '&:hover': {
      backgroundColor: 'rgb(90, 210, 150)',
    }
  },
  default: {
    backgroundColor: GlobalStyles.color.COLOR_DEFAULT,
  },
  topContainer: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 30px',
    justifyContent: 'space-between',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    transition: 'all 0.2s ease-in-out',
    [theme.breakpoints.down(400)]: {
      padding: '10px 10px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
    '&:hover': {
      transition: 'all 0.2s ease-in-out',
      width: '104%',
      marginLeft: '-2%',
      borderRadius: 15,
    }
  },
  dateTimeContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  bottomContainer: {
    display: 'flex',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    padding: 20,
    flexDirection: 'column',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    [theme.breakpoints.down(400)]: {
      padding: 10,
      color: GlobalStyles.color.COLOR_BLACK_GREY,
    },
  },
  statusAndLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
    [theme.breakpoints.down(400)]: {
      flexDirection: 'column',
    },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  boldValues: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  bottomText: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  mainLink: {
    '&:hover': {
      textDecoration: 'none',
    }
  },
  linkButton: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  linkButtonsContainer: {
    paddingLeft: 5,
  },
  findLocationContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 70,
    width: '100%',
    marginTop: 20,
    padding: 10,
    borderRadius: 10,
    webkitBoxShadow: '9px 9px 30px -20px rgba(0,0,0,0.75)',
    mozBoxShadow: '9px 9px 30px -20px rgba(0,0,0,0.75)',
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
  },
  textFindLocationContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
  },
  textFindLocation: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
  arrangeCollectionTitle: {
    width: '100%',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_SECONDARY,
    textAlign: 'center',
  },
  textHermes: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GREY,
  },
  shopImage: {
    width: 25,
    height: 25,
  },
  carImage: {
    width: 35,
    height: 25,
  },
  sliderText: {
    marginTop: 20,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    textAlign: 'center',
  },
});

export default styles;
